import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { NavLink, withRouter } from 'react-router-dom';
import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Pagination } from '../../../components/Pagination';
import { selectWorks } from '../../Api/selectors';
import { changeProductFilter, fetchProducts } from '../actions';
import { REQUEST_PRODUCTS, REQUEST_UPDATE_PRODUCT } from '../constants';
import { ProductSearch } from '../components/Search';
import { ProductsOverviewTable } from '../components/ProductsOverviewTable';
import { selectItemsCount, selectPaginator, selectProductFilter, selectProducts } from '../selectors';
import { ProductSearchType } from '../components/ProductSearchType';
import { ProductSearchStatus } from '../components/ProductSearchStatus';
import { FiltersCloud } from '../components/FiltersCloud';
import { PageHeader } from '../../../components/PageHeader';
import { ChevronRight, Home } from '../../../components/Icon';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';

const Container = styled.div`
  .form-controlField {
    margin-bottom: 0;
  }

  .nav-link {
    cursor: pointer;
  }

  .nav-link.active {
    color: blue;
  }
`;

const TopNavbar = styled.div`
  background-color: white;
  padding: 12px 24px;
  margin: 24px 6px;
  width: 100%;
`;

const STATE = {
  currentPage: 0,
};

/* eslint-disable react/prefer-stateless-function */
class ProductsOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.fetch();
  }

  get products() {
    return this.props.products;
  }

  get isActiveNavLink() {
    return this.props.history.location?.pathname === '/products';
  }

  selectPage = newPage => {
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter('offset', newOffset));
  };

  render() {
    if (this.props.work || !this.props.filter) return <Loader small />;

    this.isActiveNavLink;

    return (
      <Container>
        <PageHeader
          title={
            <>
              {/* <Home /> */}
              {this.lbl('product.overview.title')} <span className="label number">{this.props.count}</span>
            </>
          }
          breadCrumbs={
            <HBox vCenter>
              <span className="nav-link" onClick={() => this.to('/')}>
                Vindat
              </span>

              <ChevronRight />
              <span className="nav-link active">{this.lbl('product.overview.title')}</span>
            </HBox>
          }
        ></PageHeader>
        <h3>
          {this.lbl('products')} ({this.props.count})
        </h3>
        <TopNavbar>
          <VBox left style={{ gap: 12, marginBottom: 12 }}>
            <div className="container-fluid p-0">
              <div className="container-fluid ps-0 pe-0 pt-2 pb-0 bg-white">
                <div className="row p-0 m-0 align-items-center">
                  <div className="col-12 mb-3 col-lg-3 mb-3 col-xl-3 mb-3">
                    <ProductSearch />
                  </div>
                </div>
                <div className="row p-0 m-0 align-items-center">
                  <div
                    className="col-12 mb-3 col-lg-6 mb-3 col-xl-3
                     mb-3"
                  >
                    <ProductSearchType filter={this.props.filter} />
                  </div>
                </div>
                <div className="row p-0 m-0 align-items-center">
                  <div
                    className="col-12 mb-3 col-lg-6 mb-3 col-xl-3
                     mb-3"
                  >
                    <ProductSearchStatus filter={this.props.filter} />
                  </div>
                </div>
              </div>
            </div>
          </VBox>

          <FiltersCloud />
        </TopNavbar>
        <Button primary small onClick={this.tofn('/products/create')}>
          +{this.lbl('add')}
        </Button>
        <div>
          <ProductsOverviewTable />
        </div>
        {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <div className="d-flex justify-content-center mt-2 mb-5 mb-md-0">
            <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
          </div>
        )}
      </Container>
    );
  }
}

ProductsOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    products: selectProducts(),
    paginator: selectPaginator(),
    count: selectItemsCount(),
    work: selectWorks([REQUEST_PRODUCTS, REQUEST_UPDATE_PRODUCT]),
    filter: selectProductFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchProducts());
    },
    changeFilter: (name, value) => {
      dispatch(changeProductFilter(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductsOverview = compose(withConnect, withRouter)(ProductsOverviewComp);
